export default __webpack_public_path__ + "static/media/Document.81ad246d.svg";